import { InterfaceTab } from "#/types/types";
import { TabRenderer } from "#/ui/tabRenderer";
import { PaneRenderer } from "#/ui/paneRenderer";

export default class UIRenderer {
    private ircClient: any;
    private tabRenderer: TabRenderer;
    private paneRenderer: PaneRenderer;

    constructor(ircClient: any) {
        this.ircClient = ircClient;
        this.tabRenderer = new TabRenderer(ircClient);
        this.paneRenderer = new PaneRenderer(ircClient);
    }

    createContainer(): void {
        const container = document.createElement('div');
        container.id = 'irc-container';
        container.className = 'irc-container';
        document.body.appendChild(container);
    }

    createTabBar(): void {
        const tabBar = document.createElement('div');
        tabBar.id = 'irc-tabbar';
        tabBar.className = 'irc-tabbar';
        const container = document.getElementById('irc-container');
        if (container) {
            container.appendChild(tabBar);
        }
    }

    createContentArea(): void {
        const contentArea = document.createElement('div');
        contentArea.id = 'irc-content';
        contentArea.className = 'irc-content';
        const container = document.getElementById('irc-container');
        if (container) {
            container.appendChild(contentArea);
        }
    }

    renderTab(tab: InterfaceTab): void {
        this.tabRenderer.renderTab(tab);
    }

    renderTabContent(tab: InterfaceTab): void {
        this.paneRenderer.renderTabContent(tab);
    }

    removeTabElement(tab: InterfaceTab): void {
        this.tabRenderer.removeTabElement(tab);
    }

    removeTabContent(tab: InterfaceTab): void {
        this.paneRenderer.removeTabContent(tab);
    }

    updateTabElementName(oldKey: string, newKey: string, newName: string): void {
        this.tabRenderer.updateTabElementName(oldKey, newKey, newName);
    }

    updateActiveTab(tab: InterfaceTab): void {
        this.tabRenderer.updateActiveTab(tab);
    }

}